export function convertBool(value) {
    return String(value) === 'true';
}